<script setup lang="ts">
definePageMeta({
  title: "Min side",
  layout: "variant",
})
</script>

<template>
  <UProfile />
</template>
